
export const NoDataColumnFormatter = ( cellContent, row, rowIndex ) => (
    ( !cellContent || cellContent === '' || cellContent === null ) ? 'N/A' : cellContent
);
